import { DESIGNER_COLOR_ID_IRI } from 'src/templates/queries/iris';
import { JsonLdResult } from 'src/templates/queries/types';
import { getJsonLdResultDescription } from 'src/utils/jsonld/getJsonLdResultDescription';
import { getJsonLdResultLabel } from 'src/utils/jsonld/getJsonLdResultLabel';
import { getJsonLdResultLocalName } from 'src/utils/jsonld/getJsonLdResultLocalName';
import { getJsonLdResultValue } from 'src/utils/jsonld/getJsonLdResultValue';

export const parseMetatdataResults = (rawResults: JsonLdResult[]) => {
  const colorIdsByIri: Record<string, string> = {};
  const descriptionsByIri: Record<string, string> = {};
  const labelsByIri: Record<string, string> = {};
  rawResults.forEach((result) => {
    // continue if the result is missing an iri
    const iri = result['@id'];
    if (typeof iri !== 'string') {
      return;
    }

    const colorValue =
      result[DESIGNER_COLOR_ID_IRI] !== undefined &&
      getJsonLdResultValue(
        result[DESIGNER_COLOR_ID_IRI],
        (_, idx) => !idx // only get first color
      );
    if (colorValue && !colorIdsByIri[iri]) {
      colorIdsByIri[iri] = colorValue;
    }

    const descriptionValue = getJsonLdResultDescription(result);
    if (descriptionValue && !descriptionsByIri[iri]) {
      descriptionsByIri[iri] = descriptionValue;
    }

    // only set the new label if there isn't an existing label
    // or the existing label was a fallback to the local name
    const labelValue = getJsonLdResultLabel(result);
    if (
      labelValue &&
      (!labelsByIri[iri] ||
        labelsByIri[iri] === getJsonLdResultLocalName(result))
    ) {
      labelsByIri[iri] = labelValue;
    }
  }, {});
  return { colorIdsByIri, descriptionsByIri, labelsByIri };
};
